import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import sidebarStyle from "../../style/components/bars/SideBar.module.css";
import { IoChatbubblesOutline } from "react-icons/io5";
import { CiHome } from "react-icons/ci";
import { CiBellOn } from "react-icons/ci";
import { IoIosMore } from "react-icons/io";
import WorkSpace from "./WorkSpace";
import {
  getSelectedCompany,
  getUserDetails,
  getUserToken,
} from "../../utils/auth";
import ProfileDropdown from "../UserToggle/ProfileToggle";
import Profile from "../../Pages/profile/Profile";
import ChangePassword from "../../Pages/auth/ChangePassword";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import { useLoginUser } from "../../hooks/useCommonHooks";
import AccountDeactive from "../ui/Warning/AccountDeactive";
import WebSocketOnline from "../../services/onlineSocketService";

const SideBar = ({ onMenuSelect, onWorkspaceUpdate = () => {} }) => {
  const location = useLocation(); // current route
  const selectedCompany = getSelectedCompany() || {};
  const { userData: loginData, refreshLoginData } = useLoginUser(); // ⬅️ destructure properly
  const [showPopup, setShowPopup] = useState(false);

  const activeMenu = (item) => {
    if (item.name === "More") {
      // List all routes that should make "More" active
      const morePaths = [
        "/accountsummary",
        "/userlist",
        "/userlist/add",
        "/companylist",
        "/companylist/add",
        "/group",
        "/group/add",
        "/channel",
        "/channel/add",
        "/userandrole",
        "/userandrole/add",
        "/logs",
        "/privacy-policy",
        "/aboutus",
      ];
      return morePaths.some((p) => location.pathname.startsWith(p));
    }
    return location.pathname.startsWith(item.path);
  };

  // const [activeMenu, setActiveMenu] = useState("General");
  const [isWorkSpaceOpen, setWorkSpaceOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isChngPaswOpen, setChngPaswOpen] = useState(false);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    const token = getUserToken();

    if (token) {
      WebSocketOnline.connect(token);
    }

    // 🔄 Send online status every 30 seconds
    const interval = setInterval(() => {
      WebSocketOnline.sendOnlineStatus?.(); // safe check before calling
    }, 5000);

    const handleBeforeUnload = () => {
      WebSocketOnline.disconnect();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      clearInterval(interval);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      WebSocketOnline.disconnect();
    };
  }, []);

  const userDetails = getUserDetails();
  const menuItems = [
    { icon: <CiHome size={20} />, name: "Home", path: "/homepage" },
    { icon: <IoChatbubblesOutline size={20} />, name: "DMS", path: "/dms" },
    { icon: <CiBellOn size={20} />, name: "Activity", path: "/activity" },
    { icon: <IoIosMore size={20} />, name: "More", path: "/accountsummary" },
    // { icon: <CiViewList />, name: 'User List', path: '/Userlist' },
  ];
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = (item) => {
    // setActiveMenu(item.name);
    if (item.action) item.action();
    if (onMenuSelect) onMenuSelect(item.name);
  };

  const openWorkSpace = () => {
    setWorkSpaceOpen(true);
  };

  const closeWorkSpace = () => {
    setWorkSpaceOpen(false);
  };

  const companyData = (data) => {
    if (data) {
      onWorkspaceUpdate(data);
    }
  };

  const openToggle = () => {
    setIsOpen(true);
  };

  const closeToggle = () => {
    setIsOpen(false);
  };

  const handleClick = (data) => {
    if (data === "Profile") {
      setProfileOpen(true);
    } else {
      setChngPaswOpen(true);
    }
  };
  // console.log(loginData.employee_details);
  useEffect(() => {
    if (loginData?.employee_details?.active === "1") {
      setShowPopup(true);
    }
  }, [loginData]);

  const closePopup = () => setShowPopup(false);

  const handleUpdate = () => {
    refreshLoginData();
  };

  return (
    <>
      <div className={sidebarStyle.sidebarContainer}>
        <div className={sidebarStyle.sidebarContainerChild}>
          <div className={sidebarStyle.sidebarHeader}>
            <div
              className={sidebarStyle.sidebarCompanyLogo}
              onClick={openWorkSpace}
            >
              <img
                src={`${BASE_URL}${selectedCompany?.company_logo}`}
                alt="Company Logo"
              />
            </div>
          </div>

          <nav className={sidebarStyle.sidebarMenus}>
            <ul>
              {menuItems.map((item) => (
                <li key={item.name} onClick={() => handleMenuClick(item)}>
                  <Link
                    to={item.path}
                    className={`${sidebarStyle.sidebarMenuList} ${
                      activeMenu(item) ? sidebarStyle.activeMenu : ""
                    }`}
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={sidebarStyle.sidebarBottom}>
            {/* <button className={sidebarStyle.sidebarMenuList} onClick={onLogout}>
              <CiLogout />
              <span>Log Out</span>
            </button> */}
            {/* <nav className={sidebarStyle.sidebarMenus}>
              <li>
                <Link className={sidebarStyle.sidebarMenuList}>
                  <CiLogout />
                  <span>Log Out</span>
                </Link>
              </li>
            </nav> */}
            <div className={sidebarStyle.sideBaruser} onClick={openToggle}>
              {imgError || !userDetails?.emp_pic ? (
                <FallbackAvatar name={userDetails?.name || "User"} size={40} />
              ) : (
                <img
                  src={`${BASE_URL}${userDetails?.emp_pic}`}
                  alt="User Logo"
                  onError={() => setImgError(true)}
                />
              )}
              <span className={sidebarStyle.OnlineIndicator}></span>
            </div>
          </div>
        </div>
      </div>
      <WorkSpace
        show={isWorkSpaceOpen}
        close={closeWorkSpace}
        companyUpdated={companyData}
      />
      {isChngPaswOpen && (
        <ChangePassword OnClose={() => setChngPaswOpen(false)} />
      )}

      <ProfileDropdown show={isOpen} close={closeToggle} Click={handleClick} />
      {isProfileOpen && (
        <Profile onClose={() => setProfileOpen(false)} upDated={handleUpdate} />
      )}
      {showPopup && <AccountDeactive onClose={closePopup} />}
    </>
  );
};

export default SideBar;
